<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<div class="block-ui-template">
  <div class="block-ui-spinner">
    <div class="loader"></div>
    <div *ngIf="message" class="message">
      {{ message }}
    </div>
    <div *ngIf="showEscape" class="message sub-message">
      <div>
        <!-- <i>The current operation has been running longer than expected [Context={{serviceContext}}]</i>     -->
        <i>The current operation has been running longer than expected</i>
      </div>
      <div class='flex-layout-row flex-layout-align-center-center flex-layout-gap-10px'>
        <span *ngIf="isSignedIn">The user is currently authenticated</span>
        <span *ngIf="!isSignedIn">The user has been signed out</span>
      </div>
      <div class='flex-layout-row flex-layout-align-center-center flex-layout-gap-10px'>
        <span>Click to reload the page</span><mat-icon (click)="escapeBlocker()">refresh</mat-icon> <span>Click for home</span><mat-icon (click)="loadWelcome()">home</mat-icon>
      </div>
    </div>
  </div>
</div>
